/**
 * In this file we will import the code that handles other types of URL changes
 * For example, product type changes, pagination changes, amenities changes, etc
 */
require('./locations');
require('./subdirectory');
require('./queryString');
require('./paging');
require('./pageUrls');
require('./builderName');
require('./mapCoordinatesUrl');